import {Stack, Typography, useTheme} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ContactBox, ContactItem, ContactLink, IconContainer} from './styles';
import {PORTAL_URL, APP_URL, CONTACTS} from './constants';
import {useCongenereDrawer} from './hooks/useCongenereDrawer';
import {FullscreenLoading} from 'presentation/components/Loading/FullscreenLoading';

const {
	title,
	bodyLine1Part1,
	bodyLine1Bold1,
	bodyLine1Part2,
	bodyLine1Bold2,
	bodyLine1Part3,
	bodyLine2Bold,
	contactBoxIntro,
	primaryButton,
	secondaryButton,
} = translations['pt-br'].privateFlow.home.congenereDrawer;
const {loading} = translations['pt-br'].commons;

export function CongenereDrawer() {
	const {palette} = useTheme();
	const {open, setOpen, markDrawerAsDismissedToday, isLoading} = useCongenereDrawer();

	if (isLoading) {
		return <FullscreenLoading text={loading} />;
	}

	return (
		<Drawer.Root
			open={open}
			onClose={() => null}
			onOpen={() => null}
			customMaxHeight="95%"
			width="420px"
			disableSwipeToOpen>
			<Drawer.Header
				onClose={() => {
					setOpen(false);
					markDrawerAsDismissedToday();
				}}
			/>
			<Drawer.Content>
				<Stack gap={2} pt={1}>
					<Stack alignItems="center">
						<IconContainer>
							<Icon name="warning" color={palette.warning.main} size={32} />
						</IconContainer>
						<Typography variant="h6">{title}</Typography>
					</Stack>

					<Typography variant="body1">
						{bodyLine1Part1}
						<strong>{bodyLine1Bold1}</strong>
						{bodyLine1Part2}
						<strong>{bodyLine1Bold2}</strong>
						{bodyLine1Part3}
						<strong>{bodyLine2Bold}</strong>
					</Typography>

					<ContactBox>
						<Typography variant="body1" mb={2}>
							{contactBoxIntro}
						</Typography>
						<Stack gap={1}>
							{CONTACTS.map(contact => (
								<Stack
									key={contact.href}
									direction="row"
									alignItems="flex-start"
									gap={0.5}>
									<Icon
										name={contact.iconName}
										color={palette.primary.main}
										size={20}
									/>
									<ContactItem>
										<Typography variant="body1">{contact.label}</Typography>
										<ContactLink
											href={contact.href}
											target={'_blank'}
											rel="noopener noreferrer">
											{contact.linkText}
										</ContactLink>
									</ContactItem>
								</Stack>
							))}
						</Stack>
					</ContactBox>
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				secondButtonOnClick={() => window.open(APP_URL, '_blank', 'noopener,noreferrer')}
				firstButtonTitle={
					<Stack direction="row" alignItems="center" gap={1}>
						<Icon name="laptop-chromebook-filled" size={18} />
						<span>{secondaryButton}</span>
					</Stack>
				}
				firstButtonOnClick={() => window.open(PORTAL_URL, '_blank', 'noopener,noreferrer')}
				secondButtonTitle={
					<Stack direction="row" alignItems="center" gap={1}>
						<Icon name="download-default" size={18} />
						<span>{primaryButton}</span>
					</Stack>
				}
				direction="column-reverse"
			/>
		</Drawer.Root>
	);
}
